import yaml from 'js-yaml'

export const asJson = (yamlOrJsonText) => {
  try {
    return JSON.parse(yamlOrJsonText)
  } catch (e) {
    try {
      return yaml.safeLoad(yamlOrJsonText)
    } catch (e) {
      throw new Error('The contract JSON or YAML is invalid. Please edit contract and try again')
    }
  }
}

export const asNumber = (value) => {
  try {
    return parseFloat(value)
  } catch (e) {
  }
  return value
}

export const isNumber = (value) => {
  try {
    return !isNaN(value) && !isNaN(parseFloat(value))
  } catch (e) {
  }
  return false
}


export const asInt = (value) => {
  try {
    return parseInt(value)
  } catch (e) {
  }
  return value
}

